import { Tooltip } from '@mui/material';
import { blue, green, red } from '@mui/material/colors';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/Block';
import LockOpenIcon from '@mui/icons-material/Flare';
import LockIcon from '@mui/icons-material/Lock';
import { AgreementStatus } from '../../common/PricePrgClient';

type Props = {
    agreementStatus?: AgreementStatus;
};

export const AgreementStatusIcon = ({ agreementStatus }: Props) => {
    if (agreementStatus == null) {
        return null;
    }

    const style = {
        fontSize: 15
    };

    const icon = (() => {
        switch (agreementStatus) {
            case AgreementStatus.Inactive:
                return (
                    <CheckBoxOutlineBlankIcon
                        color="primary"
                        style={{
                            ...style,
                            color: red[500]
                        }}
                    />
                );
            case AgreementStatus.New:
                return (
                    <LockOpenIcon
                        color="primary"
                        style={{
                            ...style,
                            color: blue[500]
                        }}
                    />
                );
            case AgreementStatus.Published:
                return (
                    <LockIcon
                        color="primary"
                        style={{
                            ...style,
                            color: green[500]
                        }}
                    />
                );
        }
    })();

    const tooltipText = (() => {
        switch (agreementStatus) {
            case AgreementStatus.Inactive:
                return 'Inactive';
            case AgreementStatus.New:
                return 'New';
            case AgreementStatus.Published:
                return 'Published';
        }
    })();

    return <Tooltip title={tooltipText}>{icon}</Tooltip>;
};
